module.exports = __webpack_public_path__ + "img/ic_store_function_img5.0e5205b6.png";